import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { makeTooltipProvider } from '../../../../../../cross-team-shared/tooltips/tooltip-utils';
import { getOutputHelper } from '../../../../../../shared/output-helpers/get-output-helper';
import {
  OutputInfo,
  outputInfoStoreToken,
} from '../../../../../h3ml/state/output-info';

@Component({
  selector: 'h3-help-button',
  templateUrl: './help-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [makeTooltipProvider({ position: 'below' })],
  standalone: false,
})
export class HelpButtonComponent extends DirectiveSuperclass {
  faQuestion = faQuestion;

  private outputInfoStore: Store<OutputInfo>;

  constructor(
    private dialog: MatDialog,
    private injector: Injector,
  ) {
    super(injector);
    this.outputInfoStore = injector.get(outputInfoStoreToken);
  }

  help() {
    const output = this.outputInfoStore.state().output;
    const helpModalType = getOutputHelper(output.type).getHelpModalType(output);
    this.dialog.open(helpModalType, {
      injector: this.injector,
      width: '875px',
      maxWidth: '875px',
    });
  }
}
